import { CUSTOM_STYLES } from '../../../constants/styles';
export var makeCustomStyles = function makeCustomStyles(version) {
  var styleVersion = version.replace(/\./g, '-');
  var styles = CUSTOM_STYLES.replace(/\{version\}/g, styleVersion);
  return styles;
};